// This is the file for the page you see the first that image with that black box and the button
import React, { useState } from 'react'
import './Banner.css'
import Search from "./Search"
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";

function Banner() {
    const history = useHistory();
    const [showSearch, setShowSearch] = useState(true);
    return (
        <div className="banner">
            {/* This the top button of the page after the header (search dates) its logic is in search.js */}
            <div className="banner__search">
                {showSearch && <Search />}
                <Button onClick={() => setShowSearch(!showSearch)} className="banner__searchbutton" variant="outlined">
                    {showSearch ? "Hide" : "Search Dates"}
                </Button>
            </div>
            {/* the black box */}
            <div className="banner__info">

                <h1>Get out and search your imagination</h1>

                <h5>Plan diffenrt kinds of gateways to uncover the hidden gems near you </h5>
                {/* the search nearby button */}
                <Button onClick={() => history.push("./search")} Variant="outlined">Search Nearby</Button>

            </div>

        </div>
    )
}
export default Banner
